// extracted by mini-css-extract-plugin
export default {"suggested":"suggested-aQMS","suggestion":"suggestion-ZPp6"};